<template>
  <MultiRadio
    v-model="squads"
    v-validate.disable="'required|numeric|min_value:2'"
    :class="'multi-radio-input-border'"
    :disabled="isTournamentFieldDisabled('squads')"
    :error="errors.first('squads')"
    :items="squadsSteps"
    required
    name="squads"
    :label="$$t('Quantity of participants:')"
    class="col-12"
    :cols-auto="false"
    custom-input-size="4"
    custom-input
    custom-placeholder=""
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import MultiRadio from '@/components/molecules/form/MultiRadio';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentSquadsSetting',
  inject: ['$validator'],
  components: {
    MultiRadio,
  },
  mixins: [translate('_web_tournament_settings')],
  data() {
    return {
      squadsSteps: [8, 16, 32, 64, 128, 256, 512, 1024],
    };
  },
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    squads: {
      get() {
        return this.$lodash.get(
          this.currentTournament,
          'players_config.squads',
          null
        );
      },
      set(newVal) {
        this.errors.remove('squads');
        this.updateCurrentTournament({
          squads: newVal,
          component: 'players_config',
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>

<style lang="scss">
.multi-radio-input-border {
  input {
    border: 1px dashed #949090;
  }
}
</style>
